<!-- 顶栏消息图标 -->
<template>
  <div class="language">
    <el-dropdown @command="handleSetLanguage">
      <div class="language-box">
        <div class="language-icon"></div>
        <p>{{ langStr }}</p>
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="en">{{ 'English' }}</el-dropdown-item>
        <el-dropdown-item command="zh">{{ '中文' }}</el-dropdown-item>
        <el-dropdown-item command="cs">{{ 'Czech' }}</el-dropdown-item>
        <!-- <el-dropdown-item command="it">{{ 'Italiano' }}</el-dropdown-item> -->
        <!-- <el-dropdown-item command="ar">{{ 'Arabic' }}</el-dropdown-item> -->
        <el-dropdown-item command="sl">{{ 'Slovene' }}</el-dropdown-item>
        <el-dropdown-item command="hr">{{ 'Croatian' }}</el-dropdown-item>
        <el-dropdown-item command="bg">{{ 'Bulgarian' }}</el-dropdown-item>
        <el-dropdown-item command="hy">{{ 'Armenian' }}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'languages',
    data() {
      return {};
    },
    computed: {
      ...mapGetters(['lang']),
      langStr() {
        if (this.lang == 'cs') {
          return 'Czech';
        } else if (this.lang == 'en') {
          return 'English';
        } else if (this.lang == 'it') {
          return 'Italiano';
        } else if (this.lang == 'ar') {
          return 'Arabic';
        } else if (this.lang == 'zh') {
          return '中文';
        } else if (this.lang == 'de') {
          return 'German';
        } else if (this.lang == 'fr') {
          return 'French';
        } else if (this.lang == 'es') {
          return 'Spanish';
        } else if (this.lang == 'pt') {
          return 'Portuguese';
        } else if (this.lang == 'sl') {
          return 'Slovene';
        } else if (this.lang == 'hr') {
          return 'Croatian';
        } else if (this.lang == 'bg') {
          return 'Bulgarian';
        } else if (this.lang == 'hy') {
          return 'Armenian';
        } else {
          return '中文';
        }
      }
    },
    methods: {
      handleSetLanguage(lang) {
        // this.$i18n.locale = lang;
        this.$store.commit('SET_LANGUAGE', lang);
        this.$emit('changeLanguage', lang);
      }
    }
  };
</script>

<style lang="scss">
  .language {
    cursor: pointer;
    display: flex;
    align-items: center;
    padding-inline-end: 18px;
    .language-box {
      display: flex;
      align-items: center;
      font-family: 'MediumFont', 'Noto Sans', 'Arial', sans-serif;
      color: #5c6467 !important;
      font-size: 20px !important;
      .language-icon {
        width: 25px;
        height: 25px;
        background: url('~@/assets/images/menu/language.png') no-repeat;
        background-size: 100% 100%;
        display: inline-block;
        margin-inline-end: 20px;
      }
    }
  }
</style>
